import React from 'react';
import { Link } from 'react-router-dom';
import { ASSETS } from '../config/assets';

const TAPELLIGENCE_URL = 'https://tapelligence.com';

/**
 * BrandLogo — YUL ON TAP emblem + "BY" + new Tapelligence wordmark.
 * Emblem links to homepage. "BY Tapelligence" links to tapelligence.com.
 */
const BrandLogo = ({ className = 'h-24 lg:h-32' }) => (
  <div className={`inline-flex flex-col items-center ${className}`} data-testid="brand-logo">
    {/* Emblem → Homepage */}
    <Link to="/" className="h-[82%] min-h-0" data-testid="logo-home-link">
      <img
        src={ASSETS.LOGO_EMBLEM}
        alt="YUL On Tap"
        className="h-full w-auto object-contain"
      />
    </Link>
    {/* BY + Tapelligence wordmark → tapelligence.com */}
    <a
      href={TAPELLIGENCE_URL}
      target="_blank"
      rel="noopener noreferrer"
      className="flex items-center gap-1 opacity-80 hover:opacity-100 transition-opacity"
      data-testid="logo-tapelligence-link"
    >
      <span className="text-[7px] lg:text-[8px] font-bold text-white/50 uppercase tracking-wider leading-none">BY</span>
      <img
        src={ASSETS.TAPELLIGENCE_LOGO}
        alt="Tapelligence"
        className="h-2 lg:h-2.5 w-auto"
      />
    </a>
  </div>
);

export default BrandLogo;
export { TAPELLIGENCE_URL };
